import { render } from "./Error.vue?vue&type=template&id=4ca05153&scoped=true&ts=true"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"

import "./Error.vue?vue&type=style&index=0&id=4ca05153&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca05153"],['__file',"src/components/layout/Error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ca05153"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ca05153', __exports__)) {
    api.reload('4ca05153', __exports__)
  }
  
  module.hot.accept("./Error.vue?vue&type=template&id=4ca05153&scoped=true&ts=true", () => {
    api.rerender('4ca05153', render)
  })

}


export default __exports__